export default "https://cdn-static.gokick.com/assets/0ba7a9ad4dd7229a35aca69ca4183ecb31843a51/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";